export function routes($stateProvider) {
  $stateProvider
    .state('app.publicacao', {
      url: '/publicacao',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.publicacao.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Publicações',
      template: require('./directory/directory.view.html'),
      controller: 'PublicacaoListController',
      controllerAs: 'vm',
      role: 'publicacaoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.publicacao.details', {
      url: '/{id}',
      title: 'Publicação',
      controller: 'PublicacaoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'publicacaoRead'
    })
    .state('app.publicacao.new', {
      url: '/nova',
      title: 'Adicionar Publicação',
      template: require('./new/new.view.html'),
      controller: 'PublicacaoCreatePublicacaoController',
      controllerAs: 'vm',
      role: 'publicacaoCreate'
    })
    .state('app.publicacao.new.1', {
      template: require('./new/publicacao.1.form.html')
    })
    .state('app.publicacao.new.2', {
      template: require('./new/publicacao.2.form.html')
    })
    .state('app.publicacao.new.3', {
      template: require('./new/publicacao.3.form.html')
    })
    .state('app.publicacao.new.4', {
      template: require('./new/publicacao.4.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
